"use client";
import { j as e } from "./jsx-runtime-CJ-St4mQ.mjs";
const l = ({
  condition: r,
  children: t,
  fallback: n = null
}) => /* @__PURE__ */ e.jsx(e.Fragment, { children: r ? t : n });
export {
  l as default
};
